import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';

import { Link } from '@comparethemarketau/manor-link';
import { Typography } from '@comparethemarketau/manor-typography';
import { footerCopyrightBannerBrandName, footerCopyrightPrivacyPolicyUrl, footerCopyrightTermsOfUseUrl  } from 'ctm-selectors/selectors/state';

const useStyles = createUseStyles((theme) => ({
    text: {
        fontSize: 'inherit',
        fontWeight: theme.fontWeight.bold,
        display: 'inline-block'
    }
}));

const FooterCopyright = (props) => {
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });
    const companyName = useSelector(footerCopyrightBannerBrandName);
    const privacyPolicyUrl = useSelector(footerCopyrightPrivacyPolicyUrl);
    const termsOfUseUrl = useSelector(footerCopyrightTermsOfUseUrl);
    const { className } = props;

    return (
        <div data-testid="footer-copyright" className={classNames('test-footer-copyright', className)}>
            <Typography component="span" className={classNames(classes.text)}>
                {`© ${companyName}. All rights reserved. `}
                <Typography className={classes.text}>
                    <Link
                        underline="none"
                        target="_blank"
                        trackingLabel={`link for ${privacyPolicyUrl}`}
                        href={ privacyPolicyUrl }
                    >
                        {'Privacy Policy'}
                    </Link>
                    {'.'}
                </Typography>
                {' '}
                <Typography className={classes.text}>
                    <Link
                        underline="none"
                        target="_blank"
                        trackingLabel={`link for ${termsOfUseUrl}`}
                        href={ termsOfUseUrl }
                    >
                        {'Website Terms of Use'}
                    </Link>
                    {'.'}
                </Typography>
            </Typography>
        </div>
    );
};

FooterCopyright.propTypes = {
    className: PropTypes.string
};

export { FooterCopyright };
